import { Platform } from 'react-native'

let appIdentifier = 'com.tranetechnologies.ui-common' // eslint-disable-line functional/no-let

export function setAppIdentifier(identifier: string) {
  appIdentifier = identifier
}

export default function tID(testID: string | undefined) {
  if (!testID) return ''

  const prefix = `${appIdentifier}:id/`
  const hasPrefix = testID.startsWith(prefix)

  return Platform.select({
    android: !hasPrefix ? `${prefix}${testID}` : testID,
    ios: hasPrefix ? testID.slice(prefix.length) : testID,
    web: testID,
  })
}

export function scrubTestID(testID?: string, suffix?: string) {
  if (!testID || testID.trim().length === 0) return tID('test-id-unknown')

  const testIDWithSuffix = suffix ? `${testID}-${suffix}` : testID
  const scrubbedTestID = testIDWithSuffix
    .trim()
    .replace(/ - /g, '-')
    .replace(/ /g, '-')
    .replace(/\./g, '')
    .toLowerCase()

  return tID(scrubbedTestID)
}
